export default __webpack_public_path__ + "static/step_5_en-2e56e636330515595c223e1a1094b257.svg";